import { render, staticRenderFns } from "./SpdRecords.vue?vue&type=template&id=a970d378&"
import script from "./SpdRecords.vue?vue&type=script&lang=js&"
export * from "./SpdRecords.vue?vue&type=script&lang=js&"
import style0 from "./SpdRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports